import  gql  from 'graphql-tag'

export const offices = gql`query Offices($isActive: Boolean) { 
    offices(isActive: $isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    email,
                    isActive,
                    regional{
                        id,
                        code,
                        name
                    }
                }
            }
        }
    }`;